import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UsersLogic } from '@core/user/users.logic';
import { UserDto } from 'src/app/api';

@Injectable({
  providedIn: 'root'
})
export class CerSessionUsersService {
  
  public users$ : BehaviorSubject<UserDto[]> = new BehaviorSubject<UserDto[]>(null);
  public onUsers(users: UserDto[]) {
    this.users$.next(users);
  }

  public usersLogic(): UsersLogic {
    var usersLogic = new UsersLogic();
    usersLogic.users = this.users$.getValue();
    return usersLogic;
  }

  public userById(id: number): UserDto {
    return this.usersLogic().userById(id);
  }

  private userByShortName(shortName: string): UserDto {
    return this.usersLogic().userByShortName(shortName);
  }

  private userByName(name: string): UserDto {
    return this.usersLogic().userByName(name);
  }

  public userNameById(id: number): string {
    return this.usersLogic().userNameById(id);
  }

  private ShortNameById(id: number): string {
    return this.usersLogic().ShortNameById(id);
  }

  private EmailById(id: number): string {
    return this.usersLogic().EmailById(id);
  }

  public avatarById(id: number): string {
    return this.usersLogic().avatarById(id);
  }

  private photoUrlById(id: number): string {
    return this.usersLogic().photoUrlById(id);
  }
}